/**
 * API génération batch de drafts (S5.5 phase 2).
 *
 * 4 endpoints sous `/api/generation-jobs/*` :
 *   - GET  /missing-drafts                → liste œuvres avec drafts manquants
 *   - POST /enqueue-batch                  → crée un batch de jobs
 *   - GET  /batch/{batch_id}               → comptes par status (polling FE)
 *   - GET  /{job_id}                       → détail d'un job
 *
 * Cf. `backend/app/api/generation_jobs.py`.
 */

import type {
  BatchStatusResponse,
  EnqueueBatchRequest,
  EnqueueBatchResponse,
  GenerationJobResponse,
  WorkMissingDraftsResponse,
} from '@/types/generation-jobs'

import { apiClient } from './client'

export const generationJobsApi = {
  listMissingDrafts: async (): Promise<WorkMissingDraftsResponse> => {
    const { data } = await apiClient.get<WorkMissingDraftsResponse>(
      '/generation-jobs/missing-drafts',
    )
    return data
  },

  enqueueBatch: async (payload: EnqueueBatchRequest): Promise<EnqueueBatchResponse> => {
    const { data } = await apiClient.post<EnqueueBatchResponse>(
      '/generation-jobs/enqueue-batch',
      payload,
    )
    return data
  },

  getBatchStatus: async (batchId: string): Promise<BatchStatusResponse> => {
    const { data } = await apiClient.get<BatchStatusResponse>(`/generation-jobs/batch/${batchId}`)
    return data
  },

  getJob: async (jobId: number): Promise<GenerationJobResponse> => {
    const { data } = await apiClient.get<GenerationJobResponse>(`/generation-jobs/${jobId}`)
    return data
  },
}
